import React from 'react';
import { CalendarDays, Users, UserCog, UserRound, Settings, MapPin, Bell, ChevronLeft, ChevronRight, Package, Clock } from 'lucide-react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { cn } from '../../../lib/utils';
import UserDropdown from '../UserDropdown/UserDropdown';

const LeftNav = ({ expanded, onToggle }) => {
  const { tenantDomain } = useParams();
  const { pathname } = useLocation();

  const navItems = [
    { icon: CalendarDays, label: 'Schedule', path: `/${tenantDomain}/home` },
    { icon: UserCog, label: 'Users', path: `/${tenantDomain}/users` },
    { icon: UserRound, label: 'Clients', path: `/${tenantDomain}/clients` },
    { icon: MapPin, label: 'Locations', path: `/${tenantDomain}/locations` },
    { icon: Package, label: 'Packages', path: `/${tenantDomain}/packages` },
    { icon: Clock, label: 'Availability', path: `/${tenantDomain}/availability` },
    { icon: Settings, label: 'Settings', path: `/${tenantDomain}/settings` },
  ];

  return (
    <aside
      className={cn(
        "fixed top-0 left-0 h-screen bg-background border-r z-20 flex flex-col transition-all duration-300",
        expanded ? "w-56" : "w-14"
      )}
    >
      {/* Logo + toggle */}
      <div className={cn(
        "flex items-center h-14 border-b px-3 shrink-0",
        expanded ? "justify-between" : "justify-center"
      )}>
        {expanded && (
          <span className="font-semibold text-base tracking-tight">Trainamic</span>
        )}
        <button
          onClick={onToggle}
          className="flex items-center justify-center w-7 h-7 rounded-md text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
        >
          {expanded ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
        </button>
      </div>

      {/* Nav items */}
      <nav className="flex-1 flex flex-col gap-0.5 p-2 pt-3">
        {navItems.map(({ icon: Icon, label, path }) => {
          const isActive = pathname === path;
          return (
            <Link
              key={label}
              to={path}
              className={cn(
                "flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors",
                isActive
                  ? "bg-accent text-primary font-medium border-l-2 border-primary rounded-l-none"
                  : "text-muted-foreground hover:bg-accent hover:text-accent-foreground font-medium"
              )}
            >
              <Icon size={17} className="shrink-0" />
              {expanded && <span>{label}</span>}
            </Link>
          );
        })}
      </nav>

      {/* Bottom: bell + user */}
      <div className={cn(
        "border-t p-2 flex flex-col gap-0.5 shrink-0",
      )}>
        <button className={cn(
          "flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors w-full",
        )}>
          <Bell size={17} className="shrink-0" />
          {expanded && <span>Notifications</span>}
        </button>
        <UserDropdown sidebar expanded={expanded} />
      </div>
    </aside>
  );
};

export default LeftNav;
